import React from 'react';
import ReactHtmlParser from 'html-react-parser';

const PageContent = (props) => {
    return (
        <article className="post-article single-post-article ">
            <div className="list-single-main-item fl-wrap block_box p-4" id="page-content">
                {ReactHtmlParser(props.content)}
            </div>
        </article>
    );
};

export default PageContent;